

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getCustomerGoldBalanceDashboard
// GETCUSTOMERGOLDBALANCEDASHBOARD
const GETCUSTOMERGOLDBALANCEDASHBOARD= createAsyncThunk(
  "getCustomerGoldBalanceDashboard/getCustomerGoldBalanceDashboard",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCustomerGoldBalanceDashboardSlice = createSlice({
  name: "getCustomerGoldBalanceDashboardSlice",
  initialState: {
    getCustomerGoldBalanceDashboard: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCustomerGoldBalanceDashboard: (state) => {
        state.getCustomerGoldBalanceDashboard.loading = false
        state.getCustomerGoldBalanceDashboard.error = false
        state.getCustomerGoldBalanceDashboard.data = []
        state.getCustomerGoldBalanceDashboard.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCUSTOMERGOLDBALANCEDASHBOARD.fulfilled, (state, action) => {
      state.getCustomerGoldBalanceDashboard = {
        ...state.getCustomerGoldBalanceDashboard,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERGOLDBALANCEDASHBOARD.pending, (state, action) => {
      state.getCustomerGoldBalanceDashboard = {
        ...state.getCustomerGoldBalanceDashboard,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCUSTOMERGOLDBALANCEDASHBOARD.rejected, (state, action) => {
      state.getCustomerGoldBalanceDashboard = {
        ...state.getCustomerGoldBalanceDashboard,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCustomerGoldBalanceDashboardAction = {
    GETCUSTOMERGOLDBALANCEDASHBOARD,
};

export { getCustomerGoldBalanceDashboardAction };
export default getCustomerGoldBalanceDashboardSlice.reducer;
export const {setInitialStateOfgetCustomerGoldBalanceDashboard} = getCustomerGoldBalanceDashboardSlice.actions